export default __webpack_public_path__ + "static/media/0-1.e76ff800.png";